<template lang="pug">
  .component-backoffice-note-list.row.column
    base-list(:component="component", :dataLoader="loadZones", :showPerPageSelect="false", ref="baseList")
</template>

<script>

  import MaggieHelper from "../../maggieHelper";
  import KeplerBackofficeSdk from "../../lib/kepler/backoffice";
  import BaseList from "./BaseList";

  export default {
    name: "InstructionList",
    components: {BaseList},
    data() {
      return {
        component: require('src/components/backoffice/Instruction'),
      }
    },
    created() {
    },
    methods: {
      loadZones(callback) {
        var instructions = {
          current_page: 1,
          current_page_count: 1,
          items: [],
          items_count: 10,
          page_count: 1,
          per_page_count: 25,
        }
        KeplerBackofficeSdk.instructions.list.all((data) => {
          instructions.items = data
          instructions.items_count = data.length
          callback(instructions)
        })
      },
    }
  }
</script>

<style scoped lang="sass">
  .component-backoffice-zone-list
    .map
      height: 400px
    .zone-edit
      color: white

</style>



// WEBPACK FOOTER //
// InstructionList.vue?56758df9